import clsx from "clsx";

export const Select = ({ items, itemToString, value, setValue, disabled=false, placeholder=null, placeholderValue=null, theme="light", size="md", className }) => {

  const handleOnChange = (e) => {
    const selectedId = e.target.value;
    if (!setValue) return;

    if (!selectedId && placeholderValue !== null) {
      setValue(placeholderValue);
    }
    else{
      const selectedItem = items?.find(item => String(item.id) === String(selectedId));
      setValue(selectedItem ?? null);
    }

  };

  const getThemeClasses = () => {
    return theme === 'light' ?
      'text-perception-gray-700 bg-gray-100' :
      'text-perception-gray-500 bg-perception-black-500 placeholder-perception-gray-700';
  };

  const getSizeClasses = () => {
    return size === 'sm' ? 'text-sm px-2 py-1 border-1' :
      size === 'lg' ? 'text-xl px-4 py-2 border-2' :
        'px-2 py-1 border-1'; // default & md
  };

  return (
    <select name="select" value={value?.id ?? ''} onChange={handleOnChange} disabled={disabled}
            className={clsx(getThemeClasses(), getSizeClasses(), 'rounded-md outline-none border-transparent focus:border-perception-blue', className)}>
      {
        placeholder && <option value="" disabled={placeholderValue === null} hidden={placeholderValue === null}>{placeholder}</option>
      }
      {
        items?.map((item, itemIndex) => (
          <option value={item.id} key={itemIndex}>{itemToString(item)}</option>
        ))
      }
    </select>
  );
};